var map = {
	"./ageras/da_DK": 90426,
	"./ageras/da_DK.json": 90426,
	"./ageras/de_DE": 69072,
	"./ageras/de_DE.json": 69072,
	"./ageras/en_US": 75907,
	"./ageras/en_US.json": 75907,
	"./ageras/fr_FR": 13962,
	"./ageras/fr_FR.json": 13962,
	"./ageras/nl_NL": 28834,
	"./ageras/nl_NL.json": 28834,
	"./billy/da_DK": 79515,
	"./billy/da_DK.json": 79515,
	"./billy/de_DE": 83861,
	"./billy/de_DE.json": 83861,
	"./billy/en_US": 9334,
	"./billy/en_US.json": 9334,
	"./billy/fr_FR": 65563,
	"./billy/fr_FR.json": 65563,
	"./billy/nl_NL": 90415,
	"./billy/nl_NL.json": 90415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89348;